/* ---------------------------------------------------------------------------
   pulp-to-top.js — back to top, both shapes

   One handler for the bar and the floating button. The floating button only
   exists visually once the visitor is past a threshold; the bar is always there.

   Scrolling honours prefers-reduced-motion: smooth for everyone else, an
   instant jump for people who have asked the OS not to animate things. A
   smooth scroll from the bottom of this homepage is a long ride, so the jump
   is arguably the kinder default anyway.
   --------------------------------------------------------------------------- */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toTop() {
    try {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0); // older Safari has no options object
    }
    // Send focus somewhere sensible so keyboard users aren't stranded at the
    // bottom of the document after the page has visually jumped to the top.
    var target = document.querySelector('#MainContent, main, h1');
    if (target) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  function init(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-pulp-totop]');
    if (!buttons.length) return;

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.pulpTotopBound) return;
      btn.dataset.pulpTotopBound = '1';
      btn.addEventListener('click', toTop);
    });

    var fabs = scope.querySelectorAll('.pulp__totop-fab[data-show-after]');
    if (!fabs.length) return;

    function sync() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      Array.prototype.forEach.call(fabs, function (fab) {
        var after = parseInt(fab.getAttribute('data-show-after'), 10) || 600;
        fab.classList.toggle('is-on', y > after);
      });
    }

    // Inside the theme editor the section is the thing being previewed, so it
    // should be visible immediately rather than only after the merchant scrolls.
    if (window.Shopify && window.Shopify.designMode) {
      Array.prototype.forEach.call(fabs, function (fab) { fab.classList.add('is-on'); });
      return;
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
